<template>
  <div class="breadcrumb">
    <template v-for="(item, index) in items" :key="index">
      <div
        v-if="item.clickable !== false && (item.route || item.onClick)"
        class="breadcrumb-item"
        @click="handleItemClick(item)"
      >
        <span class="breadcrumb-label">{{ item.label }}</span>
      </div>
      <div v-else class="breadcrumb-item breadcrumb-item-current">
        <span class="breadcrumb-label">{{ item.label }}</span>
      </div>
      <Icon v-if="index < items.length - 1" icon="mdi:chevron-right" class="breadcrumb-separator" />
    </template>
  </div>
</template>

<script setup lang="ts">
import { Icon } from "@iconify/vue";
import { useRouter } from "vue-router";

interface BreadcrumbItem {
  label: string;
  route?: string | { name: string; params?: Record<string, any> };
  icon?: string;
  clickable?: boolean;
  onClick?: () => void;
}

interface Props {
  items: BreadcrumbItem[];
}

const props = defineProps<Props>();
const router = useRouter();

const handleItemClick = (item: BreadcrumbItem) => {
  if (item.onClick) {
    item.onClick();
  } else if (item.route) {
    if (typeof item.route === "string") {
      router.push(item.route);
    } else {
      router.push(item.route);
    }
  }
};
</script>

<style scoped>
.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  background-color: transparent !important;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.breadcrumb-item:hover {
  opacity: 0.8;
}

.breadcrumb-item:hover .breadcrumb-label {
  color: #3e3efe;
}

.breadcrumb-item-current {
  cursor: default;
}

.breadcrumb-item-current:hover {
  opacity: 1;
}

.breadcrumb-label {
  font-size: 14px;
  font-weight: 600 !important;
  color: #101828;
  transition: color 0.2s ease;
}

.breadcrumb-item-current .breadcrumb-label {
  font-weight: 700 !important;
  color: #101828;
}

.breadcrumb-separator {
  font-size: 16px;
  color: #9ca3af;
  margin: 0 2px;
}
</style>
